// extracted by mini-css-extract-plugin
export default {"wrapper":"Annotation_wrapper__6ZMkq","annotation":"Annotation_annotation__jG6IW"};